import React, { VFC } from 'react';
import { View, Image, StyleSheet, TouchableOpacity } from 'react-native';
import { ButtonBase, Colors, getRadius, getSpacing } from '@rahtab/ui';
import AddIcon from './AddIcon';

const ProviderImage: VFC<ProviderImageProps> = ({ imageUri, onPress }) => {
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <View>
        {!!imageUri && <Image source={{ uri: imageUri }} style={styles.image} />}
        {!imageUri && (
          <AddIcon
            style={{
              height: 50,
              width: 50,
            }}
          />
        )}
      </View>
    </TouchableOpacity>
  );
};

export default ProviderImage;

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    marginBottom: getSpacing(),
    height: 150,
    width: 150,
    backgroundColor: Colors.darkGray,
    borderRadius: getRadius(),
    marginTop: getSpacing(),
  },
  image: {
    height: 150,
    width: 150,
    borderRadius: getRadius(),
  },
});

interface ProviderImageProps {
  imageUri?: string;
  onPress?: () => void;
}
